module.exports = __webpack_public_path__ + "static/media/iconService1.b0a0f782.svg";